const filterString = (str) => {
  return str.replace(/[^a-zA-Zа-яА-Я0-9]/g, '').toLowerCase()
}

export default filterString
